import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Autocomplete from "@mui/material/Autocomplete";

import { useState } from "react";

import { useSetRecoilState, useRecoilValue } from "recoil";

import { searchState, captionsState } from "./RecoilStates";

import { activeProject } from "./Auth";

export function Search({ onSearch }) {
  const [value, setValue] = useState("");
  const setSearch = useSetRecoilState(searchState);
  const captions = useRecoilValue(captionsState);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const doSearch = (query) => {
    if (!query) {
      return;
    }

    if (onSearch) {
      onSearch(query.trim());
    }
    setSearch(query.trim());
    setValue("");
  };

  const handleSearch = () => {
    doSearch(value);
  };

  const handleKey = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const handleAutocomplete = (e, val) => {
    if (e.type === "click") {
      doSearch(val);
    }
  };

  return (
    <Autocomplete
      freeSolo
      autoHighlight
      // autoSelect
      clearOnEscape
      clearOnBlur
      value={value}
      onChange={handleAutocomplete}
      options={
        activeProject in captions ? Object.keys(captions[activeProject]) : []
      }
      size="small"
      sx={{ pl: 1, width: 170 }}
      componentsProps={{ popper: { style: { width: "fit-content" } } }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          size="small"
          autoFocus
          placeholder="Search"
          value={value}
          onChange={handleChange}
          onKeyDown={handleKey}
          InputProps={{
            ...params.InputProps,
            style: { fontSize: 12 },
            startAdornment: (
              <InputAdornment position="start">
                <IconButton
                  component="span"
                  size="small"
                  onClick={handleSearch}
                  disabled={value.trim().length === 0}
                >
                  <SearchIcon fontSize="inherit" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  );
}
